/** A company's status badge (an approved switch to Solar OS). Its name comes from the API (the backend's
 * domain/badges.py: not final), so no screen hard-codes it. */
import { Award } from "lucide-react";
import type { S } from "../api/client";
import { date } from "../lib/format";

export function StatusBadge({ badge, size = "md" }: { badge: S["StatusBadge"] | null | undefined; size?: "sm" | "md" }) {
  if (!badge) return null;
  return (
    <span className={`status-badge${size === "sm" ? " is-sm" : ""}`} title={badge.since ? `${badge.name} since ${date(badge.since)}` : badge.name} data-testid="status-badge">
      <Award aria-hidden="true" />
      {badge.name}
    </span>
  );
}
